import Icon from "./controls/icon/icon";
import "./LabelMessage.scss";
interface IPropsLabelMessage {
    message: string;
    valid: boolean;
    isLabelError?: boolean;
}
 
export default function LabelMessage (props: IPropsLabelMessage) {
    let label_color= props.isLabelError ?  'text-danger' : 'text-gray';

    return (
        <div className={`${props.valid ? 'd-none': 'd-flex' } align-items-center justify-content-start mb-4 mt-1`}>
            <Icon name="info" className={`me-2 fs-18 ${label_color}`} />
            <label className={`message ${label_color} mb-0 text-start fs-11`}>
                {props.message}
            </label>
        </div>
    )
}
 
    